export default __webpack_public_path__ + "static/media/gerpal1.375dde40.jpg";